import React, { Component } from 'react'
import ActionCableContainer from 'containers/ActionCableContainer'
import BillingModalContainer from 'containers/BillingModalContainer'
import Visit from 'components/Visit'
import { connect } from 'react-redux'
import {
  toggleMicrophone,
  toggleCamera,
  endVisit,
  getGvcUrlByJwt
} from 'actions/api/visits'
import {
  storeRoomStats
} from 'actions/api/stats'
import {
  setUserTrackDetails,
  videoServiceInitialized,
  visitUnconnected,
  startupMessageReceived
} from 'actions/visits'
import {
  openDialog
} from 'actions/dialog'
import VisitEndedModalContainer from 'containers/VisitEndedModalContainer'
import UnconnectedVisitModalContainer from 'containers/UnconnectedVisitModalContainer'
import { setVisitStatus } from 'actions/visits'
import BrowserValidatorContainer from 'containers/BrowserValidatorContainer'
import BreakInWarningMessageModalContainer from 'containers/BreakInWarningMessageModalContainer'
import ConfirmDialogContainer from 'containers/ConfirmDialogContainer'
import StartupMessageBannerContainer from 'containers/StartupMessageBannerContainer'
import {isVisManager} from 'utils/visManager'
import queryString from 'query-string'
import { storeClientInfo } from 'actions/api/stats'
import { withMediaAvailabilityCheck } from 'utils/hocs'
import { ERROR } from 'constants/unconnectedVisitReasons'

const JOIN_VISIT_PATH = '/visit/join'

class VisitContainer extends Component {
  constructor(props) {
    super(props)
  }
  
  componentDidMount() {
    const {
      jwt,
      getGvcUrlByJwt
    } = this.props
    if (!isVisManager() && this.isMobile()) {
      getGvcUrlByJwt(jwt, (res) => this.redirectToUserCountryURL(res.url))
    }
  }

  isMobile() {
    return ['Android', 'iPhone', 'iPad'].some(function (userAgent) {
      return window.navigator.userAgent.includes(userAgent)
    })
  }

  redirectToUserCountryURL(url) {
    const {
      location: {
        pathname,
        search
      }
    } = this.props

    if (url && !localStorage.getItem("redirected")) {
      localStorage.setItem("redirected", true)
      const redirectURL = `${url}/#${pathname}${search}`
      window.location.replace(redirectURL)
    }
  }

  render() {
    const {
      webrtcToken,
      roomName,
      twilioRoomCreatedAt,
      participantIds,
      toggleMicrophone,
      toggleCamera,
      endingSoon,
      scheduledEndTime,
      visitStatus,
      setVisitStatus,
      endVisit,
      setUserTrackDetails,
      userTracks,
      redirectURL,
      visitEnded,
      appointmentId,
      jwt,
      userToken,
      storeRoomStats,
      isFlex10Visit,
      storeClientInfo,
      isSuspended,
      useVignette,
      useBlurredVignette,
      allowedToRecord,
      videoServiceInitialized,
      confirmDialog,
      showErrorModal,
      location: {
        pathname,
        search
      }
    } = this.props

    const hideControls = queryString.parse(search.substr(1)).hide_controls === 'true'
    const isInitiator = !pathname.startsWith(JOIN_VISIT_PATH)

    return (
      <div>
        <BrowserValidatorContainer>
          <ConfirmDialogContainer />
          <UnconnectedVisitModalContainer isInitiator={isInitiator} />
          <BreakInWarningMessageModalContainer />
          <StartupMessageBannerContainer />
          { !isVisManager() && (
            <VisitEndedModalContainer />
          )}
          <BillingModalContainer
            isInitiator={isInitiator}
            isVisManager={isVisManager()}
            confirmDialog={confirmDialog}
          />
          <ActionCableContainer channelName='VisitNotificationsChannel' />
          <Visit
            isInitiator={isInitiator}
            webrtcToken={webrtcToken}
            roomName={roomName}
            twilioRoomCreatedAt={twilioRoomCreatedAt}
            participantIds={participantIds}
            toggleMicrophone={toggleMicrophone}
            toggleCamera={toggleCamera}
            endingSoon={endingSoon}
            scheduledEndTime={scheduledEndTime}
            visitStatus={visitStatus}
            setVisitStatus={setVisitStatus}
            endVisit={endVisit}
            setUserTrackDetails={setUserTrackDetails}
            userTracks={userTracks}
            redirectURL={redirectURL}
            visitEnded={visitEnded}
            appointmentId={appointmentId}
            jwt={jwt}
            userToken={userToken}
            storeRoomStats={storeRoomStats}
            hideControls={hideControls}
            isFlex10Visit={isFlex10Visit}
            storeClientInfo={storeClientInfo}
            isSuspended={isSuspended}
            useVignette={useVignette}
            useBlurredVignette={useBlurredVignette}
            allowedToRecord={allowedToRecord}
            videoServiceInitialized={videoServiceInitialized}
            confirmDialog={confirmDialog}
            showErrorModal={showErrorModal}
          />
        </BrowserValidatorContainer>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    roomName: state.visit.roomName,
    webrtcToken: state.visit.webrtcToken,
    twilioRoomCreatedAt: state.visit.twilioRoomCreatedAt,
    participantIds: state.visit.participantIds,
    scheduledEndTime: state.visit.scheduledEndTime,
    visitStatus: state.visit.visitStatus,
    userTracks: state.userTracks,
    redirectURL: state.visit.redirectURL,
    visitEnded: state.visit.visitEnded,
    appointmentId: state.visit.appointmentId,
    jwt: state.visit.jwtToken,
    userToken: state.visit.userToken,
    isFlex10Visit: state.visit.isFlex10Visit,
    isSuspended: state.visit.isSuspended,
    useVignette: state.visit.useVignette,
    useBlurredVignette: state.visit.useBlurredVignette,
    allowedToRecord: state.visit.allowedToRecord
  }
}

function mapDispatchToProps (dispatch) {
  return {
    toggleMicrophone: (act) => dispatch(toggleMicrophone(act)),
    toggleCamera: (act) => dispatch(toggleCamera(act)),
    setVisitStatus: (status) => dispatch(setVisitStatus(status)),
    endVisit: (onSuccess) => dispatch(endVisit(onSuccess)),
    setUserTrackDetails: (details) => dispatch(setUserTrackDetails(details)),
    storeRoomStats: (stats) => dispatch(storeRoomStats(stats)),
    storeClientInfo: (clientInfo) => dispatch(storeClientInfo(clientInfo)),
    getGvcUrlByJwt: (jwt, onSuccess) => dispatch(getGvcUrlByJwt(jwt, onSuccess)),
    videoServiceInitialized: (videoService) => dispatch(videoServiceInitialized(videoService)),
    confirmDialog: (onAccept) => dispatch(openDialog()).then(onAccept, () => {}),
    showErrorModal: () => dispatch(visitUnconnected(ERROR)),
    dispatchStartupMessage: (text, duration, persistent) => dispatch(startupMessageReceived(text, duration, persistent))

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withMediaAvailabilityCheck(VisitContainer))
